
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import urls from '../../constants/urls.js';
import * as browserCheck from '../../utils/browserCheck.js';

const SocialIcons = () => { 
    function getDisplay(){
        if(browserCheck.canUseDom() && window.location.pathname == '/') {
            return { display: 'none' };
        }
        else {
            return {};
        }
         
    }
    //we need to refactor this as a class componenent so we can do the check in the did mount and ensure it gets updated when transferring from SSR to client rendering. 
    return null;/* (
        <div>
            <div id="staticbox" className="staticbox" style={getDisplay()}>
                <a href={urls.FACEBOOK_URL} className="btn-soc btn-fb transition" target="_blank">Facebook</a>
                <a href={urls.TWITTER_URL} className="btn-soc btn-tw transition" target="_blank">Twitter</a>
            </div>
        </div>
    );*/
};

export default SocialIcons;